import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { PatientSelect as PatientSelectUi } from "@madmedical/ui";
import { invariant } from "@madmedical/utils";
import useRouteNavigate from "../routing/useRouteNavigate";
import useMe from "../useMe";
import { useRepresentedPatient } from "../representedPatient";
const PatientSelect = () => {
    const { patient, representative } = useMe();
    const { representedPatient, setRepresentedPatient } = useRepresentedPatient();
    const navigate = useRouteNavigate();
    const patients = useMemo(() => {
        var _a;
        const patients = (_a = representative === null || representative === void 0 ? void 0 : representative.representedPatients.slice()) !== null && _a !== void 0 ? _a : [];
        if (patient) {
            patients.unshift(patient);
        }
        return patients;
    }, [representative, patient]);
    const handleChange = useCallback((patientId) => {
        const selected = patients.find((patient) => patient.userId === patientId);
        invariant(selected);
        setRepresentedPatient(selected);
        navigate("dashboard", {});
    }, [patients, setRepresentedPatient, navigate]);
    if (!representedPatient) {
        return null;
    }
    return (_jsx(PatientSelectUi, { selectedPatient: representedPatient, me: patient, patients: patients, onChange: handleChange }));
};
export default PatientSelect;
